import { Button } from '@workramp/ui';
import { useSearch } from '../../providers';

export const AdvancedSearchFilterReset = () => {
  const { I18n } = window;

  const { resetFilters, areFiltersActive } = useSearch();

  if (!areFiltersActive) {
    return null;
  }

  return (
    <Button onPress={resetFilters} variant="text">
      {I18n.t('js.learner.advanced_search.reset')}
    </Button>
  );
};
